import React from 'react';
import classnames from 'classnames';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import ActionBarStrip from '../../_partials/ActionBarStrip';
import { useDeviationAttributes } from '../../../DeviationViews/hooks/useDeviationAttributes';
import SubscribersOnly from '../../_partials/SubscribersOnly';
import CommentButton from '../../buttons/CommentButton';
import FavouriteButton from '../../buttons/FavouriteButtonWithPopover';
import AddToGroupButtonWithPopover from '../../buttons/AddToGroupButton/AddToGroupButtonWithPopover';
import MoreButton from '../../buttons/MoreButton';
import EditButton from '../../buttons/EditButton';
import EditBackgroundButton from '../../buttons/EditBackgroundButton';
import DeleteButton from '../../buttons/DeleteButton';
import TheaterButton from '../../buttons/TheaterButton';
import ExpandButton from '../../buttons/ExpandButton';
import TierButton from '../../buttons/TierButton';
import BoostButton from '../../buttons/BoostButton';
import { ActionBarProps as Props } from '../../types';

import s from './TierActionBar.scss';

export const TierActionBar: React.FC<React.PropsWithChildren<Props>> = ({
  deviation,
  isOwner,
  className,
}) => {
  const {
    hasMoreActions,
    isCommentable,
    isEditable,
    isDeletable,
    isFavouritable,
    isGroupSubmittable,
    isBackgroundEditable,
    isBoostable,
  } = useDeviationAttributes(deviation, isOwner);

  return (
    <ActionBarStrip className={classnames(s['root'], s['seller-discounts'], className)}>
      <div className={s['indicators']}>
        <SubscribersOnly deviation={deviation} />
      </div>

      <div className={s['actions']}>
        <div className={s['main-actions']}>
          {isFavouritable && <FavouriteButton deviation={deviation} actionBarType="primary" />}
          {isCommentable && (
            <CommentButton
              deviation={deviation}
              // TODO: this is a hack to show the 'comment' label because we have the space, owner or not
              isOwner={false}
              actionBarType="primary"
            />
          )}
        </div>

        <div className={s['extra-actions']}>
          {isBoostable && <BoostButton deviation={deviation} />}
          {isGroupSubmittable && <AddToGroupButtonWithPopover deviation={deviation} actionBarType="primary" />}
          {!isOwner && (
            <BiLoggerContextProvider value={{ referral_info: ReferralType.TIER_UNIQUE }}>
              <TierButton deviation={deviation} className={s['subscribe-button']} />
            </BiLoggerContextProvider>
          )}
          {hasMoreActions && <MoreButton deviation={deviation} />}
          {isBackgroundEditable && <EditBackgroundButton deviation={deviation} />}
          {isDeletable && <DeleteButton deviation={deviation} />}
          {isEditable && <EditButton deviation={deviation} />}
        </div>
      </div>

      <div className={s['view-controls']}>
        <TheaterButton deviation={deviation} />
        <ExpandButton deviation={deviation} />
      </div>
    </ActionBarStrip>
  );
};
TierActionBar.displayName = 'TierActionBar';

export default TierActionBar;
